import { render } from "./Charts.vue?vue&type=template&id=6e8bf9a7"
import script from "./Charts.vue?vue&type=script&lang=ts"
export * from "./Charts.vue?vue&type=script&lang=ts"
script.render = render

export default script